
































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { CustomerModel } from "@/shared/models/vCustomer";
import { Country } from "@/shared/models/country";
import { DataOptions } from "vuetify";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import { ListModel } from "@/shared/models/listModel";
import VCustomer from "@/shared/models/vCustomer";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import CustomerForm from "@/components/CustomerForm.vue";

import * as _ from "lodash";
import { CustomerTypeEnum } from "@/shared/models/enums.type";
import { policyChecker } from "@/shared/roles";
import { JwtClaims } from "@/store/modules/auth";

@Component({
  components: {
    RightDrawer,
    CustomerForm,
  },
})
export default class CustomerLookup extends Vue {
  @Prop({ default: false }) open!: boolean;
  @Prop({ default: true }) canCreateNewCustomer?: boolean;
  @Prop({ default: false }) multiple?: boolean;
  @Prop({ default: null }) filterPrefil?: any;
  @Prop({ default: true }) loadImmediately?: boolean;
  @Prop() isLegalEntity?: boolean;
  @Prop({ default: false }) onlyOwners?: boolean;
  @Prop({ default: () => [] }) selected?: VCustomer[];

  @Action("codebooks/refreshCountries") refreshCountries?: () => Promise<void>;
  @Getter("codebooks/countries") countries?: Country[];

  @Getter("auth/claims") claims?: JwtClaims;

  @Watch("open")
  openWatch(fresh: boolean, old: boolean) {
    if (fresh && !old) {
      this.filters.countryOfResidenceId = undefined;
      if (this.filterPrefil) {
        this.filters = {
          ...this.filters,
          ...this.filterPrefil,
        }
      }

      if (this.selected) {
        this.selection = [...this.selected];
      }
    }
    }

  customerFormOpen = false;

  async created() {
    const promises = [];
    if ((this.countries?.length ?? 0) === 0 && this.refreshCountries) {
      promises.push(this.refreshCountries());
    }

    await Promise.all(promises);
  }

  mounted() {
    if (this.loadImmediately) {
      this.load();
     }
  }

  @Prop() lookupHeaders?: { text: string; value: string }[];
  get translatedHeaders() {
    const headers = (this.lookupHeaders === undefined || this.lookupHeaders.length === 0) ? this.defaultHeaders : this.lookupHeaders;
    return (
      headers.map((x) => ({
        ...x,
        text: this.$t(x.text),
      })) ?? []
    );
  }

  get defaultHeaders() {
    return [
      {
        text: "VCustomer.name",
        value: "name",
      },
      {
        text: "VCustomer.countryOfResidenceName",
        value: "countryOfResidenceName",
      },
      ...(this.showEmail
        ? [
            {
              text: "VCustomer.eMail",
              value: "eMail",
            },
          ]
        : []),
      ...(this.isAllowedToSeeTelephoneNumber
        ? [
            {
              text: "VCustomer.telephoneNumber",
              value: "telephoneNumber",
            },
          ]
        : []),
      
    ];
  } 

  get showEmail() {
    return policyChecker("READ_CUSTOMER_EMAIL")(this.claims)
  }

  get isAllowedToSeeTelephoneNumber() {
    return policyChecker("READ_CUSTOMER_TELEPHONE_NUMBER")(this.claims);
  }

  filters = {
    name: "",
    eMail: "",
    telephoneNumber: "",
    countryOfResidenceId: undefined as number | undefined,
    excludeIds: [] as number[],
  };
  @Watch("filters", { deep: true })
  filtersChanged() {
    this.options.page = 1;
    this.debouncedLoad();
  }

  get filtersForParams() {
    const combinedFilters = {
    ...this.filters,           
    ...this.filterPrefil,      
  };
    return {
      ...this.filters,
      excludeIds: combinedFilters.excludeIds.join(","),
    };
  }
  
  get customerFormPrefilData() {
    const names = (this.filters.name ?? "").split(" ");
    return {
      firstName: names.splice(0, 1)[0] || "",
      lastName: names.join(" "),
      eMail: this.filters.eMail,
      telephoneNumber: this.filters.telephoneNumber,
      countryOfResidenceId: this.filters.countryOfResidenceId,
    };
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 25,
    sortBy: ["orderByName"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };
  @Watch("options", { deep: true })
  optionsChanged(fresh: DataOptions, old: DataOptions) {
    if (!_.isEqual(fresh, old)) {
      this.load();
    }
  }

  debouncedLoad = _.debounce(this.load, 500);

  loading = false;
  list: ListModel<VCustomer> = {
    count: 0,
    result: [],
  };

  async load(): Promise<ListModel<VCustomer>> {
    this.loading = true;
    return this.axios
      .get<ListModel<VCustomer>>("/customers", {
        params: this.queryParams,
      })
      .then((res) => {
        this.list = res.data;
        return this.list;
      })
      .finally(() => (this.loading = false));
  }

  get queryParams() {
    return {
      $skip: this.options.itemsPerPage * (this.options.page - 1),
      $top: this.options.itemsPerPage,
      $orderby: formatOrderbyArray(
        this.options.sortBy[0] == 'name' ? ["orderByName"] : this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
      ...this.filtersForParams,
      onlyLegalEntities: this.isLegalEntity,
      customerTypeId: this.onlyOwners ? CustomerTypeEnum.Owner : null,
    };
  }

  // selection
  selection: VCustomer[] = [];
  selectCustomer() {
    if (this.selection.length > 0) {
      if (!this.multiple) {
        const selected = this.selection[0];
        this.$emit("selected", selected);
      } else {
        this.$emit("selected", this.selection);
      }

      this.selection = [];
      this.$emit("update:open", false);
    }
  }

  newCustomerCreated(customer: CustomerModel) {
    if (!this.multiple) {
      this.$emit("selected", customer);
    } else {
      const selection = [] as CustomerModel[];
      selection.push(customer);
      this.$emit("selected", selection);
    }

    this.selection = [];
    this.$emit("update:open", false);
  }
}
